/**
 * liste.ts
 *
 * NE İŞE YARAR : Liste yanıtını ekranların gördüğü tek biçime çevirir
 * KAYNAK SPEC  : 04-api-sozlesmesi.md §2.7 (listeleme sözleşmesi)
 *                DURUM.md — "Verilen karar: liste yanıtı biçimi" (2026-08-31 05:38:11)
 * BAĞLI OLDUĞU : — (saf dönüşüm)
 * KULLANAN     : Liste çeken bütün ekranlar
 * DİKKAT       : 1) TEK ANAHTAR OKUNUR: `items`. Bu dosya bir dönem **iki** anahtarı da
 *                   tanıyordu (`veri` ve `items`), çünkü arka uçtaki 28 uç sözleşmeden
 *                   sapmıştı. Sapma 25. adımda kapatıldı ve esneklik **kaldırıldı**:
 *                   duran bir esneklik, geri gelen bir sapmayı sessizce gizlerdi ve
 *                   ayrışmayı bir daha kimse fark etmezdi.
 *                2) `next_cursor` `null` OLABİLİR ve bu *"son sayfa"* demektir; alanın
 *                   hiç olmaması da aynı anlama gelir. İkisi ayrı tutulsaydı, ekranların
 *                   *"daha var mı"* sorusu iki farklı yoldan cevaplanırdı.
 *                3) TOPLAM SAYI YOKTUR (`04` §2.7) ve istemci saymaz: sayılan şey yalnız
 *                   yüklenmiş satırlar olurdu ve kullanıcı onu toplam sanardı.
 * SON GÜNCELLEME: 2026-08-31 06:05:00
 */

/** Çözülmüş liste — ekranların gördüğü tek biçim. */
export interface Liste<T> {
  readonly satirlar: readonly T[];
  /** `04` §2.7 — son sayfada `null`. */
  readonly sonrakiImlec: string | null;
}

/** Ham liste yanıtı — `04` §2.7'nin gövdesi. */
interface HamListe {
  readonly items?: unknown;
  readonly next_cursor?: unknown;
}

export function listeyiCoz<T>(ham: unknown): Liste<T> {
  const govde = (ham ?? {}) as HamListe;

  return {
    satirlar: Array.isArray(govde.items) ? (govde.items as T[]) : [],
    sonrakiImlec: typeof govde.next_cursor === 'string' ? govde.next_cursor : null,
  };
}
